<template>
  <div class="flex align-center justify-center overlay">
    <transition name="fadeScale">
      <div v-if="alartDialog"
           class="window no--sb oval transition overflow-hidden relative"
           :class="{active: alartDialog}">
        <div class="flex justify-center align-center header">
          <h3 class="title text-center">リセットしてもよろしいですか？</h3>
          <button v-if="!alartDialog.visible" @click="toggleAlartDialog(false)" class="transition pointer">
            <img src="../../assets/svg/close.svg" alt="close button">
          </button>
        </div>
        <div class="content tab2SpecH">
          <ul class="resetMeu flex justify-center flex-wrap">
            <li>
              <button @click="resetToTop()" class="resetBtn">リセットして最初に戻る</button>
            </li>
            <li>
              <button @click="toggleAlartDialog(false)">リセットしない</button>
            </li>
          </ul>
        </div>
        
      </div>
    </transition>
  </div>
</template>

<script>
import {computed, ref, watch} from "vue";
import {useStore} from "vuex";
import useRoutePush from "@/modules/moduleA/helpers/useRoutePush";


export default {
  name: "alartDialog",
  setup(){
    const store = useStore()
    const {pushTo} = useRoutePush()
    
    const alartDialog = computed(() => {
      return store.state.alartDialog
    })
    const toggleAlartDialog = (param) => {
      store.commit("setAlartDialog", param);
    }
    const resetToTop = () => {
      toggleAlartDialog(false)
      pushTo('ModuleA', {})
    }
    return {pushTo,toggleAlartDialog, alartDialog, resetToTop}
  }

}
</script>

<style scoped>
.overlay {
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0,0,0,.3);
}
.overlay > .window {
  max-width: 95%;
  width: auto;
  height: auto;
  max-height: 90%;
  background-color: white;
  box-shadow: 0 1px 2px rgba(0,0,0,0.07),
              0 2px 4px rgba(0,0,0,0.07),
              0 4px 8px rgba(0,0,0,0.07),
              0 8px 16px rgba(0,0,0,0.07),
              0 16px 32px rgba(0,0,0,0.07),
              0 32px 64px rgba(0,0,0,0.07);
  padding: 10px 30px 60px;
}
.overlay > .window > .header {
  position: relative;
  width: 100%;
  height: 70px;
  padding: 0 20px;
  border-bottom: 1px solid #f5f6fa;
}
.overlay > .window > .header > h3.title {
  position: absolute;
  left: 50%;
  width: 100%;
  font-weight: 400;
  font-size: 1.2rem;
  top: 50%;
  transform: translate(-50%, -50%);
}
.overlay > .window > .header > button {
  margin-left: auto;
  height: 40px;
  width: 40px;
}
.overlay > .window > .header > button:hover {
  background-color: whitesmoke;
  border-radius: 14px;
}
.overlay > .window > .header > button > img {
  position: relative;
  top: 2px;
  width: 20px;
  height: 20px;
}
.overlay > .window > .content {
  height: calc(100% - 90px)
}
.overlay > .window > .content > .resetMeu {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.overlay > .window > .content > .resetMeu button {
  position: relative;
  z-index: 2;
  min-width: 100px;
  height: 40px;
  margin: 60px 10px 10px;
  padding: 0px 20px;
  letter-spacing: 1.2px;
  background-color: rgba(245, 246, 250, .3);
  border: 1px solid #171717;
  color: #22252f;
  border-radius: 30px;
  font-size: .9rem;
  transition: .3s;
}
.overlay > .window > .content > .resetMeu .resetBtn {
  background-color: rgba(231, 76, 60, .1) ;
} 
.overlay > .window > .content > .resetMeu button:hover {
  background-color: #171717;
  color: #fff;
}


@media screen and (max-width: 736px) {
  .overlay > .window > .header > h3.title {
    text-align: left;
  }
  .overlay > .window > .header > button {
    margin-right: -10px;
}
  .overlay > .window > .content > .resetMeu li {
    width: 100%;
  }
  .overlay > .window > .content > .resetMeu button {
    width: 90%;
    height: 50px;
    margin: 20px 10px 10px;
  }
}

</style>
